module.exports = __webpack_public_path__ + "static/media/sport3.889c0456.jpg";